export default "assets/images/quote-fremoire-bg-51c4cdbd.svg";